import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  entityIconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useStyles;
